import { createContext, useContext } from 'react';

type FormsTemplatesDisplayContext = 'MODAL' | 'ACTION_BAR';

const formsTemplatesDisplayContext = createContext<FormsTemplatesDisplayContext | null>(null);

export const useFormsTemplatesDisplayContext = (): FormsTemplatesDisplayContext | null => {
   return useContext(formsTemplatesDisplayContext);
};

const { Provider } = formsTemplatesDisplayContext;

type FormsTemplatesDisplayContextProviderProps = {
   readonly value: FormsTemplatesDisplayContext;
   readonly children: JSX.Element;
};

export const FormsTemplatesDisplayContextProvider = (props: FormsTemplatesDisplayContextProviderProps): JSX.Element => {
   return <Provider value={props.value}>{props.children}</Provider>;
};
